"use client"

import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table'
import { Kbd } from '../ui/kbd'
import { useEffect, useState } from 'react'
import { DeleteView } from '@/app/deployment/delete/page'
import DeleteDomainModal from './DeleteDomainModal'
import { Separator } from '../ui/separator'
import PermaDeleteDomainModal from './PermaDeleteDomainModal'
import { getNormalDomains, getPermaDeleteDomains } from '@/services/domains.service'

interface Props {
    domains: DeleteView[],
    permaDeleteDomains: DeleteView[]
}

export default function DeleteTable(props: Props) {
    const [currentDomains, setCurrentDomains] = useState<DeleteView[]>([]);
    const [permaDeleteDomains, setPermaDeleteDomains] = useState<DeleteView[]>([]);

    const updateDomains = async () => {
        const domains = await getNormalDomains();
        if(domains.length > 0){
            const arr = domains.map(d => {
                return {ID: d.ID, Name: d.Name, DBRel: d.DBRel, Website: d.Website, Folder: d.Folder, Package: d.Package, CompanyID: Number(d.CompanyID)}
            });
            setCurrentDomains(arr);
        } else {
            setCurrentDomains([]);
        }
    }

    const updatePermaDeleteDomains = async () => {
        const permaDelteDomains = await getPermaDeleteDomains();
        if(permaDelteDomains.length > 0){
            const arr = permaDelteDomains.map(d => {
                return {ID: d.ID, Name: d.Name, DBRel: d.DBRel, Website: d.Website, Folder: d.Folder, Package: d.Package, CompanyID: Number(d.CompanyID)}
            });
            setPermaDeleteDomains(arr);
        } else {
            setPermaDeleteDomains([]);
        }
    }

    const updateBoth = () => {
        setCurrentDomains([]);
        setPermaDeleteDomains([]);
        updateDomains();
        updatePermaDeleteDomains();
    }

    useEffect(() => {
        if(currentDomains.length === 0) {
            setCurrentDomains(props.domains);
        }
        if(permaDeleteDomains.length === 0) {
            setPermaDeleteDomains(props.permaDeleteDomains);
        }
    }, [currentDomains, props.domains, permaDeleteDomains, props.permaDeleteDomains]);

    return <div>
        <h1 className="text-xl font-bold text-black dark:text-white mb-2">
            Delete Domain
        </h1>
        <Table>
            <TableHeader>
                <TableRow>
                    <TableHead>#</TableHead>
                    <TableHead>Navn / database</TableHead>
                    <TableHead>Website / mappe</TableHead>
                    <TableHead>Pakke</TableHead>
                    <TableHead>Delete</TableHead>
                </TableRow>
            </TableHeader>
            <TableBody>
                {currentDomains?.map((domain) => (
                    <TableRow key={domain.ID}>
                        <TableCell>{domain.ID}</TableCell>
                        <TableCell>{domain.Name} <Kbd>{domain.DBRel}</Kbd></TableCell>
                        <TableCell>{domain.Website} <Kbd>{domain.Folder}</Kbd></TableCell>
                        <TableCell>{domain.Package}</TableCell>
                        <TableCell>
                            <DeleteDomainModal domain={domain} updateData={updateBoth}></DeleteDomainModal>
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
        <Separator className='mt-3 mb-3'/>
        <h1 className="w-full text-xl font-bold text-black dark:text-white mb-2 py-1 px-2 rounded-md bg-red-500">
            Permanent Delete
        </h1>
        <Table>
            <TableHeader>
                <TableRow>
                    <TableHead>#</TableHead>
                    <TableHead>Navn / database</TableHead>
                    <TableHead>Website / mappe</TableHead>
                    <TableHead>Delete</TableHead>
                </TableRow>
            </TableHeader>
            <TableBody>
                {permaDeleteDomains?.map((domain) => (
                    <TableRow key={domain.ID} className='cursor-pointer'>
                        <TableCell>{domain.ID}</TableCell>
                        <TableCell>{domain.Name} <Kbd>{domain.DBRel}</Kbd></TableCell>
                        <TableCell>{domain.Website} <Kbd>{domain.Folder}</Kbd></TableCell>
                        <TableCell>
                            <PermaDeleteDomainModal domain={domain} updateData={updateBoth}></PermaDeleteDomainModal>
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    </div>
}